/**
 * @file Manages styles for Paragraph atom.
 * @author kkumari
 */
import { css } from 'styled-components';
import breakPoints from '../../../themes/breakpoints';
export default css([""]);